import { render, staticRenderFns } from "./property-results-card-tile.vue?vue&type=template&id=2989f357&scoped=true&"
import script from "./property-results-card-tile.vue?vue&type=script&lang=ts&"
export * from "./property-results-card-tile.vue?vue&type=script&lang=ts&"
import style0 from "./property-results-card-tile.vue?vue&type=style&index=0&id=2989f357&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2989f357",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VRow})
